import { Link } from '@remix-run/react';
import { GQLLinkTilesFragment } from '@theprintbar/graphql';
import { cn } from '@theprintbar/shared';
import { ImageContainer } from '@theprintbar/ui';

interface LinkTilesProps {
	titles?: (string | null | undefined)[];
	content: Pick<GQLLinkTilesFragment, 'linkTiles'>;
	hasContainer?: boolean;
	imageClassName?: string;
}

export function LinkTiles({ titles, content, hasContainer, imageClassName }: LinkTilesProps) {
	const tiles = content.linkTiles?.structure;
	if (!tiles) return null;

	return (
		<div className={cn('grid grid-cols-2 lg:grid-cols-6 gap-7 px-4 lg:px-8', hasContainer && 'px-0 lg:px-0')}>
			{tiles.map((tile, index) => (
				<Link prefetch="intent" to={tile?.to || '#'} key={index} className="hover:scale-105 duration-500 transition-all">
					<ImageContainer
						image={tile?.promoImage}
						className={cn('rounded-3xl aspect-square border border-blue mb-4', imageClassName)}
					/>
					{/*{titles && titles.length > 0 && <h5 className="text-xs mb-2 uppercase">{titles[index]}</h5>}*/}
					<p className={cn('font-display font-light text-lg lg:text-xl text-center')}>
						{titles && titles.length > 0 ? titles[index] : tile?.text}
					</p>
				</Link>
			))}
		</div>
	);
}
